import { ReactNode } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton } from '@mui/material';
import { ThemeToggle } from './ThemeToggle';
import { useDevice } from '~/lib/auth/device-context';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

export function Layout({ children }: { children: ReactNode }) {
    const { cashierName } = useDevice();
    const location = useLocation();
    const navigate = useNavigate();

    const isHome = location.pathname === '/';

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    bgcolor: 'primary.main',
                    borderBottom: 1,
                    borderColor: 'divider',
                    px: { xs: 1, sm: 2 }, // Added padding
                }}
            >
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    {/* Left Side: PWA Icon & Back Button */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        {!isHome && (
                            <IconButton 
                                onClick={() => navigate(-1)} 
                                edge="start" 
                                color="inherit"
                                aria-label="back"
                            >
                                <ArrowBack />
                            </IconButton>
                        )}
                        
                        <Box 
                            onClick={() => {
                                // Force full page reload to ensure clean state reset
                                window.location.href = '/';
                            }}
                            sx={{ 
                                width: 40, 
                                height: 40, 
                                bgcolor: 'primary.light', 
                                borderRadius: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                cursor: 'pointer',
                                '&:hover': { opacity: 0.9 }
                            }}
                        >
                            <img src="/icon-192.png" alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </Box>
                    </Box>

                    {/* Right Side: Greeting */}
                    <Box sx={{ textAlign: 'right' }}>
                        {cashierName ? (
                            <>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                    أهلاً يا {cashierName}
                                </Typography>
                                <Typography variant="caption" sx={{ opacity: 0.9, display: { xs: 'none', sm: 'block' } }}>
                                    ابحث عن العميل بالباركود أو رقم التليفون
                                </Typography>
                            </>
                        ) : (
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                نظام الكاش باك                            </Typography>
                        )}
                    </Box>
                </Toolbar>
            </AppBar>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    bgcolor: 'background.default',
                    overflow: 'auto',
                    p: 2,
                }}
            >
                {children}
            </Box>

            {/* Minimalist Footer */}
            <Box 
                component="footer" 
                sx={{ 
                    py: 2, 
                    px: 3, 
                    mt: 'auto', 
                    borderTop: 1, 
                    borderColor: 'divider',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'background.paper'
                }}
            >
                <Typography variant="caption" color="text.secondary">
                    تصميم وتطوير راديو مصر
                </Typography>
                <ThemeToggle />
            </Box>
        </Box>
    );
}
